import { Link } from 'react-router-dom';
import DisclaimerBanner from '@/components/DisclaimerBanner';

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <main className="mx-auto w-full max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <header className="mb-12 flex items-center justify-between gap-4 border-b border-border pb-6">
          <Link to="/" className="font-playfair text-2xl font-bold tracking-tight text-foreground hover:text-primary">
            MyLegal<span className="text-primary">AI</span>
          </Link>
          <Link to="/archive" className="text-sm font-medium text-primary underline underline-offset-4">Archive notice</Link>
        </header>

        <div className="space-y-8">
          <div>
            <p className="mb-3 text-sm font-medium uppercase tracking-wider text-muted-foreground">Static archive</p>
            <h1 className="text-4xl font-bold tracking-tight">Privacy policy</h1>
            <p className="mt-3 text-sm text-muted-foreground">Last updated: 30 August 2026</p>
          </div>

          <DisclaimerBanner />

          <section className="space-y-3">
            <h2 className="text-2xl font-bold">1. Scope</h2>
            <p className="leading-relaxed text-muted-foreground">
              MyLegalAI is an archived experimental public-interest project. This site now provides only static informational pages and links to external resources. The interactive AI service is no longer accepting users.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-2xl font-bold">2. Information handled by this archive</h2>
            <p className="leading-relaxed text-muted-foreground">
              The archive has no account registration, login, password reset, document upload, chat, template, or contact-submission feature. It does not ask visitors to provide personal information and has no connection to the former application database or AI provider.
            </p>
            <p className="leading-relaxed text-muted-foreground">
              The hosting provider may process ordinary technical request data, such as an IP address, browser information, and request timestamps, under its own policies. The archive itself does not use that data to build user profiles.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-2xl font-bold">3. External links</h2>
            <p className="leading-relaxed text-muted-foreground">
              The <Link to="/resources" className="text-primary underline underline-offset-4">resources page</Link> links to government, legal-aid, emergency, and other third-party websites. Those organisations control their own content, data practices, and contact channels. Review their policies before submitting information to them.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-2xl font-bold">4. Retained historical data</h2>
            <p className="leading-relaxed text-muted-foreground">
              This static archive is not a data-recovery or account-support channel. No account, document, or chat request can be made through it. Questions about historical records should not be sent through the site; the former interactive service is retired.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-2xl font-bold">5. Changes</h2>
            <p className="leading-relaxed text-muted-foreground">
              This policy may be updated if the static archive, its hosting, or its external links change. The date above identifies the current published version.
            </p>
          </section>
        </div>

        <footer className="mt-12 flex gap-4 border-t border-border pt-8 text-sm">
          <Link to="/terms" className="flex-1 rounded-lg border border-border px-4 py-3 text-center text-primary hover:bg-muted">Terms and disclaimer</Link>
          <Link to="/" className="flex-1 rounded-lg bg-primary px-4 py-3 text-center text-primary-foreground hover:bg-primary/80">Back to archive</Link>
        </footer>
      </main>
    </div>
  );
}
